import { render, staticRenderFns } from "./salesReturnHistory.vue?vue&type=template&id=edf745da&scoped=true"
import script from "./salesReturnHistory.vue?vue&type=script&lang=js"
export * from "./salesReturnHistory.vue?vue&type=script&lang=js"
import style0 from "./salesReturnHistory.vue?vue&type=style&index=0&id=edf745da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf745da",
  null
  
)

export default component.exports